<div class="shift">
  <div class="topbar">
    <!-- <div class="topbar__left">
      <dsy-content-switcher [contentList]="switchItems" [functionSetterData]="handleSwitch"> </dsy-content-switcher>
    </div> -->
    <div class="topbar__right">
      @if (selectionStore.selectedCountSignal() == 0) {
        <dsy-button [iconSide]="'left'" [iconName]="'download'" [iconLibrary]="'material'" [iconSize]="'1.16rem'" variant="link" color="neutral" (click)="exportCSV()"
          >Export CSV</dsy-button
        >
        <dsy-button icon-side="left" icon-name="add" [iconSize]="'1.16rem'" icon-library="material" variant="primary" (click)="handleCreate()"> Create Shift Log </dsy-button>
      } @else {
        <dsy-button icon-side="left" icon-name="add" [iconSize]="'1.16rem'" icon-library="material" variant="secondary" (click)="handleDeleteLogs()"> Delete Activity </dsy-button>
      }
    </div>
  </div>
  <dr-ops-stream-ui-shift-filters [options]="filterOptionsSignal()" (filtersChange)="onFiltersChange($event)"> </dr-ops-stream-ui-shift-filters>
  <dr-ops-stream-ui-table-state [isLoading]="isLoadingSignal()" [hasData]="showTableSignal()" [totalItems]="filteredLogsSignal().length" emptyTitle="No shift logs found.">
    <dr-ops-stream-ui-shift-table (viewLog)="handleView($event)" (editLog)="handleEdit($event)" [rows]="pagedLogsSignal()" />
  </dr-ops-stream-ui-table-state>
</div>
